export default __webpack_public_path__ + "static/media/47_BottomLeftSquares_Flip.aae3f788.mp4";